import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { StorageActions } from '@store/reducers/manager/storage'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  REQUEST_ATTACHMENTS_TIMEOUT,
  REQUEST_USER_LIMITS_TIMEOUT,
} from '@/constants/constants'
import { useAuth } from '@/hooks'
import useUser from './useUser'

const useIntervals = () => {
  const dispatch = useDispatch()
  const auth = useAuth()

  const fetchAttachmentsStorageInterval = useRef<ReturnType<
    typeof setInterval
  > | null>(null)

  const getUserStorageLimitsInterval = useRef<ReturnType<
    typeof setInterval
  > | null>(null)

  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const { getStorageLimits } = useUser()

  const handleInitStorage = () => {
    if (!projectId) {
      return
    }

    dispatch(StorageActions.init({ id: projectId }))
  }

  // Стартовую загрузку storage/attachments делает fetchProjectSaga (и она же
  // при рефетче прав после логина и на коннекте сокета); для проекта,
  // созданного на месте, первый init — как раз сокетный рефетч.
  // Здесь — только периодическое обновление
  useEffect(() => {
    if (fetchAttachmentsStorageInterval?.current) {
      clearInterval(fetchAttachmentsStorageInterval.current)
    }

    fetchAttachmentsStorageInterval.current = setInterval(
      handleInitStorage,
      REQUEST_ATTACHMENTS_TIMEOUT
    )

    return () => {
      if (fetchAttachmentsStorageInterval?.current) {
        clearInterval(fetchAttachmentsStorageInterval.current)
      }
    }
  }, [projectId])

  // Лимиты юзера нужны только в открытом проекте (бейдж хранилища, загрузка
  // файлов): ждём и проект, и авторизацию. Иначе на холодном старте запрос
  // уходил по SET_AUTH до проекта, а интервал без projectId не создавался
  useEffect(() => {
    if (!projectId) {
      return
    }

    getStorageLimits()

    if (getUserStorageLimitsInterval?.current) {
      clearInterval(getUserStorageLimitsInterval.current)
    }

    getUserStorageLimitsInterval.current = setInterval(
      getStorageLimits,
      REQUEST_USER_LIMITS_TIMEOUT
    )

    return () => {
      if (getUserStorageLimitsInterval?.current) {
        clearInterval(getUserStorageLimitsInterval.current)
      }
    }
  }, [auth.authenticated, projectId])
}

export default useIntervals
